import parseUri from 'parse-uri';

const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;

export const getAgentNif = () => {
  const uri = parseUri(window.location.href);
  return uri.queryKey.agentNif ? uri.queryKey.agentNif : null;
};

export const validateEmail = (value) => {
  // eslint-disable-next-line
  const emailRegex = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;

  if (value !== undefined && emailRegex.test(value)) {
    return undefined;
  }
  return 'La dirección de correo electrónico no es válida';
};

export const getProductList = (config) => {
  let productList = [];
  for (let i = 0; i < config.families.length; i += 1) {
    const family = config.families[i];
    for (let j = 0; j < family.products.length; j += 1) {
      productList.push(family.products[j]);
    }
  }
  return productList;
};

export const getWebBaseUrl = () => {
  switch (env) {
    case "production":
      return 'https://www.divinapastora.com';
    default:
      return 'https://web-app-divina-stg.azurewebsites.net';
  }
};



// WEBPACK FOOTER //
// ./src/functions.js